export const NOTIFICATIONS_API_ENDPOINTS = {
  NOTIFICATIONS: "/internal/operations/notifications",
  markAsRead: (id: string) =>
    `/internal/operations/notifications/${encodeURIComponent(id)}/read`,
} as const;

export const NOTIFICATION_EVENTS = {
  CONFIRMATION_CREATED: "confirmation:created",
  CONFIRMATION_UPDATED: "confirmation:updated",
  CONFIRMATION_NOTIFIED: "confirmation:notified",
  CONFIRMATION_TAKER_REMINDER: "operation.confirmation.takerReminder",
  PAYMENT_TAKER_REMINDER: "operation.payment.takerReminder",
} as const;

export const NOTIFICATION_SOCKET_EVENTS = [
  "payment:created",
  "payment:cancelled",
  "payment:updated",
  "payment:inProgress",
  "payment:filed",
  "confirmation:created",
  "confirmation:updated",
  "confirmation:notified",
  "note:created",
  "operation.confirmation.takerReminder",
  "operation.payment.takerReminder",
] as const;

export type NotificationSocketEventName = (typeof NOTIFICATION_SOCKET_EVENTS)[number];

export const SOCKET_EVENT_MARK_READ = "notification:markRead";
export const SOCKET_EVENT_MARK_READ_OK = "notification:markRead:ok";
export const SOCKET_EVENT_MARKED_READ_BROADCAST = "notification:markedRead";

export const NOTIFICATIONS_PAGE_SIZE = 20;

export const NOTIFICATION_SOUND_PATH = "/audio/notification.mp3";
export const NOTIFICATION_SOUND_REPEAT_INTERVAL_MS = 9_500;
